import { ReduceStore } from 'flux/utils';

import { ActionTypes } from 'constants/AvatarConstants';
import { dispatcher } from 'lib/Dispatcher';
import GroupAvatars from 'collections/GroupAvatars';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
// @ts-expect-error ts-migrate(2314) FIXME: Generic type 'FluxReduceStore<TState, TPayload>' r... Remove this comment to see the full error message
class AvatarStore extends ReduceStore {
  getInitialState() {
    return {
      groupAvatars: {
        loaded: false,
        collection: new GroupAvatars(),
      },
    };
  }

  getGroupAvatars(): GroupAvatars {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getState' does not exist on type 'Avatar... Remove this comment to see the full error message
    return this.getState().groupAvatars.collection;
  }

  areGroupAvatarsLoaded(): boolean {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getState' does not exist on type 'Avatar... Remove this comment to see the full error message
    return this.getState().groupAvatars.loaded;
  }

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
  reduce(state, action) {
    switch (action.type) {
      case ActionTypes.GROUP_AVATARS_LOADED:
        return {
          groupAvatars: {
            loaded: true,
            collection: action.avatars,
          },
        };
      default:
        return state;
    }
  }
}

// @ts-expect-error ts-migrate(2351) FIXME: This expression is not constructable.
export default new AvatarStore(dispatcher);
